module.exports = __webpack_public_path__ + "img/icon_win.95e8ccd9.png";